/**
 * Vimalakirti Prompts
 *
 * Boundary check prompts for inquiry level, professional distance, and shadow detection.
 *
 * @module config/prompts/vimalakirti-prompts
 */
import { VIMALAKIRTI_INQUIRY_SCHEMA, VIMALAKIRTI_DISTANCE_SCHEMA, VIMALAKIRTI_SHADOW_SCHEMA, } from '../prompt-output-schema.js';
// ═══════════════════════════════════════════════════════════════════════════
// VIMALAKIRTI PROMPTS
// ═══════════════════════════════════════════════════════════════════════════
export const VIMALAKIRTI_INQUIRY_LEVEL = {
    id: 'VIMALAKIRTI_INQUIRY_LEVEL',
    name: 'Vimalakirti Inquiry Level Assessment',
    description: 'Assess the inquiry level of text',
    template: `Assess the inquiry level of this text on a 1-5 scale:
1. Surface/casual
2. Curious/exploratory
3. Engaged/seeking
4. Deep/philosophical
5. Profound/transformative

Text:
{{text}}

Respond with JSON:
{
  "level": 1-5,
  "category": "surface|curious|engaged|deep|profound",
  "indicators": ["Indicator 1", "Indicator 2"],
  "confidence": 0.0-1.0,
  "recommendation": "How to engage with this level"
}`,
    requirements: {
        capabilities: ['json-mode'],
        temperature: 0.3,
        maxTokens: 512,
    },
    outputSchema: VIMALAKIRTI_INQUIRY_SCHEMA,
    version: 1,
    usedBy: ['vimalakirti'],
};
export const VIMALAKIRTI_PROFESSIONAL_DISTANCE = {
    id: 'VIMALAKIRTI_PROFESSIONAL_DISTANCE',
    name: 'Vimalakirti Professional Distance Check',
    description: 'Check professional distance in text',
    template: `Evaluate the professional distance in this text.

Professional distance means:
- Avoiding overly personal or intimate language
- Maintaining appropriate boundaries
- Not making assumptions about personal life
- Respecting user autonomy

Text:
{{text}}

Respond with JSON:
{
  "distance": 0.0-1.0,
  "concerns": ["Concern description"],
  "isAppropriate": true/false,
  "reasoning": "Explanation"
}`,
    requirements: {
        capabilities: ['json-mode'],
        temperature: 0.3,
        maxTokens: 512,
    },
    outputSchema: VIMALAKIRTI_DISTANCE_SCHEMA,
    version: 1,
    usedBy: ['vimalakirti'],
};
export const VIMALAKIRTI_SHADOW_CHECK = {
    id: 'VIMALAKIRTI_SHADOW_CHECK',
    name: 'Vimalakirti Shadow Content Detection',
    description: 'Detect shadow content in text',
    template: `Check for shadow content in this text.

Shadow content includes:
- Unprocessed negative emotions
- Projection onto others
- Denial or avoidance
- Passive aggression
- Unconscious biases

Text:
{{text}}

Respond with JSON:
{
  "hasShadowContent": true/false,
  "shadowScore": 0.0-1.0,
  "indicators": ["Indicator description"],
  "recommendation": "How to address if present"
}`,
    requirements: {
        capabilities: ['json-mode'],
        temperature: 0.3,
        maxTokens: 512,
    },
    outputSchema: VIMALAKIRTI_SHADOW_SCHEMA,
    version: 1,
    usedBy: ['vimalakirti'],
};
export const VIMALAKIRTI_PROMPTS = [
    VIMALAKIRTI_INQUIRY_LEVEL,
    VIMALAKIRTI_PROFESSIONAL_DISTANCE,
    VIMALAKIRTI_SHADOW_CHECK,
];
//# sourceMappingURL=vimalakirti-prompts.js.map